import { render, staticRenderFns } from "./applicationAuthMenuTemplate.vue?vue&type=template&id=6b621c70&scoped=true&"
import script from "./applicationAuthMenuTemplate.vue?vue&type=script&lang=js&"
export * from "./applicationAuthMenuTemplate.vue?vue&type=script&lang=js&"
import style0 from "./applicationAuthMenuTemplate.vue?vue&type=style&index=0&id=6b621c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b621c70",
  null
  
)

export default component.exports